import { Loader } from "@vds/loaders";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { DropdownSelect } from "@vds/selects";
import { Typography } from "@vds/typography";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UniqueNameInput from "../../../global/components/UniqueNameInput";
import { SELECT_APP_SITE_CONSTANTS, ROI_REDUX_PROPS } from "../../../global/constants/constants";
import {
  CVAPP_PERSON_DETECTION,
  CVAPP_VEHICLE_DETECTION,
  CVAPP_OBJECTBLUR,
  CV_APP_TYPE_EVENT,
  CV_APP_TYPE_EE,
  CV_APP_TYPE_OA,
} from "../../../global/constants/cvappConstants";
import {
  getCvAppCategory,
} from "../../../global/utility/cvAppUtils";
import { deployedRoiList, getCVAppLocationData, getCVAppLocationDataFromAppName } from "../../../global/utility/Utils";
import { resetRuleValue , updateRuleValue } from "../../../store/actions";
import "../bulkrule.css";
import { CREATERULE_TEST_IDS } from "./createRuleConstants";

function SelectAppSite() {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isValidAlertName, setIsValidAlertName] = useState(false);
  const [loading, setLoading] = useState(false);

  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];
  const { siteSelected, appSelected, ruleName, cvAppRois, filteredSiteList } = useSelector(
    (state) => state.ruleReducer
  );
  const roiList = useSelector((state) => state.deviceReducer.roiList) || [];
  const roiListItem = useSelector((state) => state.polygonRoiReducer.roiListWithCvapps) || [];
  const sitesTagLists =
  useSelector((state) =>  state.sitesReducer.siteTagList ) || [];
  const alertList =
    useSelector((state) => state.alertsListReducer.rules) || [];
  const sitesList = sitesTagLists?.sites || [];
  const [sitesTagList, setSiteTagList] = useState(sitesTagLists?.sites || []);
  const [tags, setTags] = useState([]);
  const navigate = useNavigate();
  // Filter CVApps to only show deployed ones
  const cvappNameListFilter = roiListItem?.filter((d) => {
    if (!d || d === null || d === undefined) {
      return false;
    }
    // Check if cvapps exists and is a valid array
    if (!d?.cvapps || d?.cvapps === null || !Array.isArray(d?.cvapps) || d?.cvapps?.length === 0) {
      return false;
    }
    
    // Check if deployments exists and is a valid array
    if (!d?.deployments || d?.deployments === null || !Array.isArray(d?.deployments) || d?.deployments?.length === 0) {
      return false;
    }
    
    // Check if first deployment exists and has valid status
    const firstDeployment = d?.deployments[0];
    if (!firstDeployment || firstDeployment === null || !firstDeployment?.status) {
      return false;
    }
    
    // Check deployment status is "deployed"
    return firstDeployment?.status === "deployed";
  }) || [];
  const deployedCvAppNames = cvappNameListFilter?.map(({ cvapps }) => {
    return cvapps?.[0]?.name;
  });
  const deployedCvAppNamesList = [...new Set(deployedCvAppNames)];

  // Filter cvAppList to only show deployed apps
  const filteredCvAppList = cvAppList.filter((app) => {
    const appDisplayName = app?.name;
    return deployedCvAppNamesList.includes(appDisplayName) &&
           app?.name !== CVAPP_OBJECTBLUR;
  });
  const filteredCvAppListWithoutRepetation = filteredCvAppList.filter(
    (app, index, self) => index === self.findIndex((a) => a.name === app.name)
  );


  const fetchCvappsLocation = async (appId, siteId) => {
    setLoading(true);
    setSiteTagList([]);
    try {
      const tagLists = await getCVAppLocationDataFromAppName(appId, activeSession,filteredCvAppList, roiListItem)
            //const tagLists2 = await getCVAppLocationData(appId, activeSession);
      if(tagLists && tagLists?.length) {
        const sites = [];
        const tagesIds =[];
        const list = [];
        if(tagLists && tagLists.length) {
           tagLists?.map((tags)=>{
            tags?.locationids?.map((tagid) => {
              const matchingListSubAreas = sitesTagLists?.subareas.filter((e) =>e.id === tagid);
              const matchingListAreas = sitesTagLists?.areas.filter((e) =>e.id === tagid);
              const matchingListFloors = sitesTagLists?.floors.filter((e) =>e.id === tagid);
              const matchingListSites = sitesTagLists?.sites.filter((e) =>e.id === tagid);
              if(matchingListSubAreas && matchingListSubAreas?.length > 0) {
                const getAreas = sitesTagLists?.areas.filter((e) =>matchingListSubAreas[0].tagids?.includes(e.id));
                const getFloor = sitesTagLists?.floors.filter((e) =>getAreas[0].tagids?.includes(e.id));
                const getSites = sitesTagLists?.sites.filter((e) =>getFloor[0].tagids?.includes(e.id));
                if(getSites?.length > 0 && !sites.some((item)=>item?.name === getSites[0]?.name)) {
                  sites.push({id:getSites[0]?.id,name: getSites[0]?.name})
                }
                list.push(...[matchingListSubAreas[0]?.id, getAreas[0]?.id, getFloor[0]?.id]);
              }
              if(matchingListAreas && matchingListAreas.length > 0) {
                const getFloor = sitesTagLists?.floors.filter((e) =>matchingListAreas[0].tagids?.includes(e.id));
                const getSites = sitesTagLists?.sites.filter((e) =>getFloor[0].tagids?.includes(e.id));
                if(!sites.some((item)=>item?.name === getSites[0]?.name) && getSites?.length > 0) {
                  sites.push({id:getSites[0]?.id,name: getSites[0]?.name})
                }

                list.push(...[matchingListAreas[0]?.id, getFloor[0]?.id]);
              }
              if(matchingListFloors && matchingListFloors?.length > 0) {

                const getSites = sitesTagLists?.sites.filter((e) =>matchingListFloors[0].tagids?.includes(e.id));
                if(getSites?.length > 0 && !sites.some((item)=>item?.name === getSites[0]?.name)) {
                  sites.push({id:getSites[0]?.id,name: getSites[0]?.name})
                }
                list.push(matchingListFloors[0]?.id);

              }
              if(matchingListSites && matchingListSites?.length > 0) {
                list.push(matchingListSites[0]?.id);
                if(matchingListSites[0] && !sites.some((item)=>item?.name === matchingListSites[0]?.name)) {
                  sites.push({id:matchingListSites[0]?.id,name: matchingListSites[0]?.name})
                }
              }
               
              if(!tagesIds.includes(tagid)) {
                tagesIds.push(tagid)
              }
            });

          });
        }

        // Only keep sites that have at least one deployed ROI for this CV app.
        // Match by name (not id) so v1/v2 versions of the same app are treated as one.
        const targetAppName = filteredCvAppList.find(f => f.id === appId)?.name;
        const sitesWithRois = sites.filter((site) =>
          roiListItem.some(
            (roi) =>
              roi?.cvapps?.some((cvapp) => cvapp.name === targetAppName) &&
              roi?.deployments?.some((dep) => dep.status?.toLowerCase() === "deployed") &&
              roi?.siteids?.includes(site.id)
          )
        );

        // Store the filtered sites in Redux
        dispatch(
          updateRuleValue([
            { propName: ROI_REDUX_PROPS.FILTERED_SITE_LIST, value: sitesWithRois },
          ])
        );
        setSiteTagList(sitesWithRois);
        setTags(tagesIds);
        setLoading(false);
      }
    } catch (error) {
      console.log("Error fetching cvapps:", error);
    }finally{
      setLoading(false);
    }
  };

  const getAppType = (cvAppList, appId) => {
    const appType = getCvAppCategory(cvAppList, appId);
    if (appType === "Entry Exit" || appType === "EntryExit") {
      return CV_APP_TYPE_EE;
    } else if (appType === "Fixed Area" || appType === "FixedArea") {
      return CV_APP_TYPE_OA;
    } else {
      return CV_APP_TYPE_EVENT;
    }
  };

  const changeValue = (e, attrName) => {
    if (attrName === ROI_REDUX_PROPS.RULE_NAME) {
      const inputValue = e.target.value;
      const isDuplicate =
        alertList && alertList?.some((rule) => rule?.name === inputValue);
      dispatch(
        updateRuleValue([
          { propName: attrName, value: e.target.value },
          { propName: ROI_REDUX_PROPS.IS_VALID_NAME, value: !isDuplicate },
        ])
      );
    } else if (attrName === ROI_REDUX_PROPS.SITE_SELECTED) {
      dispatch(
        resetRuleValue([
          ROI_REDUX_PROPS.ROI_SELECTED,
          ROI_REDUX_PROPS.FLOOR_SELECTED,
          ROI_REDUX_PROPS.FLOOR_IMAGE_DATA,
          ROI_REDUX_PROPS.FLOOR_DATA,
          ROI_REDUX_PROPS.FLOOR_ROI_LIST,
          ROI_REDUX_PROPS.CHANGED_PARKING_OCCUPANCY,
          ROI_REDUX_PROPS.SITES_ROI_LIST,
          ROI_REDUX_PROPS.SELECTED_LOCATION,
          ROI_REDUX_PROPS.ROI_DATAS,
        ])
      );
      const selText = e.target[e.target.selectedIndex].text;
      dispatch(
        updateRuleValue([
          {
            propName: attrName,
            value: { id: e.target.value, name: selText },
          },
          { propName: ROI_REDUX_PROPS.SELECTED_TAB, value: 0 },
        ])
      );
    } else if (attrName === ROI_REDUX_PROPS.APP_SELECTED) {
      dispatch(
        resetRuleValue([
          ROI_REDUX_PROPS.SELECTED_LOCATION,
          ROI_REDUX_PROPS.ROI_DATAS,
          ROI_REDUX_PROPS.ROI_SELECTED,
          ROI_REDUX_PROPS.CV_APP_ROIS,
          ROI_REDUX_PROPS.TRIGGER_DATA,
          ROI_REDUX_PROPS.TRIGGER_ACTIONS,
          ROI_REDUX_PROPS.COLORS_SELECTED,
          ROI_REDUX_PROPS.SITE_SELECTED,
          ROI_REDUX_PROPS.FLOOR_ROI_LIST,
          ROI_REDUX_PROPS.FLOOR_SELECTED,
          ROI_REDUX_PROPS.CHANGED_PARKING_OCCUPANCY,
          ROI_REDUX_PROPS.SITES_ROI_LIST,
          ROI_REDUX_PROPS.FILTERED_SITE_LIST,
          ROI_REDUX_PROPS.FLOOR_DATA,
        ])
      );
      const selText = e.target[e.target.selectedIndex].text;
      const appType = getAppType(cvAppList, e.target.value);
      dispatch(
        updateRuleValue([
          {
            propName: attrName,
            value: { id: e.target.value, name: selText },
          },
          { propName: ROI_REDUX_PROPS.SEL_APP_TYPE, value: appType },
        ])
      );
    }
  };

  useEffect(() => {
    if (cvAppRois?.length === 0) {
      if (appSelected?.id) {
        const roiListApiResponse = () => {
          try {
            // v1/v2 versions of the same app share a display name but have different
            // ids, and the App dropdown dedupes by name (only one id is selectable).
            // Match ROIs against every id sharing that name so the selected app's
            // ROIs show regardless of which version's id ended up in the dropdown.
            const canonicalAppName = filteredCvAppList.find((app) => app.id === appSelected?.id)?.name;
            if (!canonicalAppName) {
              dispatch(
                updateRuleValue({
                  propName: ROI_REDUX_PROPS.CV_APP_ROIS,
                  value: [],
                })
              );
              return;
            }
            const matchingAppIds = new Set(
              filteredCvAppList
                .filter((app) => app.name === canonicalAppName)
                .map((app) => app.id)
            );
            const appFilteredRoiList = roiListItem.filter((roi) =>
              roi?.cvapps?.some((cvapp) => cvapp?.id && matchingAppIds.has(cvapp.id))
            );
            const filteredRoiList = deployedRoiList(roiList, appFilteredRoiList);
            dispatch(
              updateRuleValue({
                propName: ROI_REDUX_PROPS.CV_APP_ROIS,
                value: filteredRoiList,
              })
            );
          } catch (e) {
            console.error("Error filtering ROI data:", e);
            dispatch(
              updateRuleValue({
                propName: ROI_REDUX_PROPS.CV_APP_ROIS,
                value: [],
              })
            );
          }
        };
        roiListApiResponse();
      }
    }
  }, [appSelected]);

  return (
    <div className="create-rule-common-container">
      {loading && <Loader active fullscreen={false} />}

      <div>
        <Typography className="bulk-rule-content-header-text">
          {SELECT_APP_SITE_CONSTANTS.HEADER_TEXT}
        </Typography>
      </div>

      <div className="appAndSite-InputWrapper">
        <UniqueNameInput
          label="Alert name"
          value={ruleName}
          defaultValue={ruleName}
          onChange={changeValue}
          data-testid={CREATERULE_TEST_IDS.ALERT_NAME_INPUT}
          error={isError}
          isError={isError}
          setIsError={setIsError}
          dataList={alertList}
          setIsValid={setIsValidAlertName}
        />
      </div>

      <div className="appAndSiteDropdown-Wrapper">
        <DropdownSelect
          label="App"
          error={false}
          onChange={(e) => {
            changeValue(e, ROI_REDUX_PROPS.APP_SELECTED)
            fetchCvappsLocation(e.target.value);
          }}
          width="100%"
          data-testid={CREATERULE_TEST_IDS.APP_DROPDOWN}
        >
          <option value="">{SELECT_APP_SITE_CONSTANTS.SELECT_OPTION}</option>
          {filteredCvAppListWithoutRepetation &&
            filteredCvAppListWithoutRepetation?.map((item) => (
              <option
                selected={item?.id === appSelected?.id}
                key={item?.id}
                value={item.id}
              >
                {item?.resources?.displayNameFull || item?.name}
              </option>
            ))}
        </DropdownSelect>

        <DropdownSelect
          label="Site"
          error={false}
          onChange={(e) => changeValue(e, ROI_REDUX_PROPS.SITE_SELECTED)}
          width="100%"
          data-testid={CREATERULE_TEST_IDS.SITE_DROPDOWN}
          disabled={!appSelected?.id}
        >
          <option value="">{SELECT_APP_SITE_CONSTANTS.SELECT_OPTION}</option>
          {[
            ...(appSelected?.id && filteredSiteList?.length > 0 
              ? filteredSiteList.map((item) => (
                  <option
                    selected={item?.id === siteSelected?.id}
                    key={item?.id}
                    value={item?.id}
                  >
                    {item?.name}
                  </option>
                ))
              : []
            ),
            ...(appSelected?.id && (!filteredSiteList || filteredSiteList.length === 0)
              ? [<option disabled>{SELECT_APP_SITE_CONSTANTS.NO_SITES}</option>]
              : []
            )
          ]}
        </DropdownSelect>
      </div>

      <Modal
        opened={showModal}
        fullScreenDialog={false}
        disableAnimation={false}
        disableOutsideClick={false}
      >
        <ModalTitle>{SELECT_APP_SITE_CONSTANTS.EMPTY_SITES_MODAL_TITLE}</ModalTitle>
        <ModalBody>
          <p>{SELECT_APP_SITE_CONSTANTS.EMPTY_SITES_MODAL_BODY_LINE1}</p>
          <p>
            {SELECT_APP_SITE_CONSTANTS.EMPTY_SITES_MODAL_BODY_LINE2}
          </p>
        </ModalBody>
        <ModalFooter
          buttonData={{
            primary: {
              width: "100%",
              children: "Continue",
              onClick: () => setShowModal(false),
              "data-testid": CREATERULE_TEST_IDS.MODAL_CONTINUE_BUTTON,
            },
            close: {
              width: "100%",
              children: "Cancel",
              onClick: () => navigate("/alerts"),
              "data-testid": CREATERULE_TEST_IDS.MODAL_CANCEL_BUTTON,
            },
          }}
        />
      </Modal>
    </div>
  );
}

export default SelectAppSite;
